import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { Permission } from "../Model/Permission";

export async function patchPermission(id, data) {
	let response = await getAPIResponse("/v1/permission/"+id, data, "PATCH");
	if (response === null) {
		return null;
	}
	let permission = Permission.createFromResponseData(response);
	return permission;
}